import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=cdd00262&scoped=true&"
import script from "./VideoContent.vue?vue&type=script&lang=ts&"
export * from "./VideoContent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoContent.vue?vue&type=style&index=1&id=cdd00262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd00262",
  null
  
)

export default component.exports